import { render, staticRenderFns } from "./template-search.vue?vue&type=template&id=ea210662&scoped=true&"
import script from "./template-search.vue?vue&type=script&lang=js&"
export * from "./template-search.vue?vue&type=script&lang=js&"
import style0 from "./template-search.vue?vue&type=style&index=0&id=ea210662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea210662",
  null
  
)

export default component.exports